'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ReactNode } from 'react';

import { navigationMenuTriggerStyle } from 'src/components';
import { cn } from 'src/lib/utils';

export interface HeaderMenuLinkProps {
  href: string;
  title: string | ReactNode;
  icon?: ReactNode;
  isActive?: boolean;
  exactMatch?: boolean;
}

export function HeaderMenuLink({
  icon,
  title,
  href,
  isActive: defaultIsActive,
  exactMatch,
}: HeaderMenuLinkProps) {
  const path = usePathname();
  const isActive = defaultIsActive ?? (exactMatch ? path === href : path.startsWith(href));

  return (
    <Link
      href={href}
      className={cn(
        navigationMenuTriggerStyle(),
        'bg-muted-90 text-muted-foreground hover:text-foreground font-normal text-sm px-3',
        isActive &&
          'font-medium text-foreground bg-white h-6 hover:bg-white border focus:bg-white focus:text-foreground shadow-sm rounded-md'
      )}
    >
      {icon}
      {title}
    </Link>
  );
}
